import {
  CallSessionDto,
  ChatSessionDto,
  JoinChatSessionDto,
  OmniChannelMessageDto,
  OutChatSessionDto,
  SpeakToTextDto,
  UpdateAgentMapSocketDto,
  UserCompactDto
} from 'types';
import { configuration, LOCAL_STORAGE_KEY, OMNI_CHANNEL_EVENT, SocketClient } from 'utils';
import { addMetadataOmniMessage } from './omni-channel.api';
import * as _ from 'lodash';
import { AgentTotalCallAndChatCounter } from 'types/dto/agent-maps/agent-total-call-and-chat-counter.dto';
import { TicketDto } from 'types/dto/ticket';

let joinedChatSessionIds: number[] = [];
export const omniChatSocketClient = new SocketClient({
  uri: configuration.OMNI_CHANNEL_SOCKET_URL || '',
  transports: ['websocket'],
  auth: {
    token: localStorage.getItem(LOCAL_STORAGE_KEY.ACCESS_TOKEN)
  },
  autoConnect: !!localStorage.getItem(LOCAL_STORAGE_KEY.ACCESS_TOKEN),
  path: configuration.OMNI_CHANNEL_SOCKET_PATH || undefined
});

omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.CONNECT, () => {
  joinedChatSessionIds.forEach((chatSessionId) => {
    joinChatSession({ chatSessionId: chatSessionId });
  });
});

export async function connectOmniChannelSocket() {
  omniChatSocketClient.connect();
}
export async function disconnectOmniChannelSocket() {
  omniChatSocketClient.disconnect();
}

/** chat session */
export function joinChatSession(joinChatSession: JoinChatSessionDto) {
  omniChatSocketClient.socket.emit(OMNI_CHANNEL_EVENT.JOIN_CHAT_SESSION, joinChatSession);
  joinedChatSessionIds = _.uniq([...joinedChatSessionIds, joinChatSession.chatSessionId]);
}

export function leaveChatSession(leaveChatSession: OutChatSessionDto) {
  omniChatSocketClient.socket.emit(OMNI_CHANNEL_EVENT.LEAVE_CHAT_SESSION, leaveChatSession);
  joinedChatSessionIds = joinedChatSessionIds.filter(
    (conversationId) => conversationId !== leaveChatSession.chatSessionId
  );
}

/** chat session processing */
export function onReceiveChatSessionProcessing(callback: (data: ChatSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.CHAT_SESSION_PROCESSING, (data) => {
    callback(data);
  });
}
export function offReceiveChatSessionProcessing() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.CHAT_SESSION_PROCESSING);
}

/** chat session waiting */
export function onReceiveChatSessionWaiting(callback: (data: ChatSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.ADD_CHAT_SESSION_WAITING, (data) => {
    callback(data);
  });
}
export function offReceiveChatSessionWaiting() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.ADD_CHAT_SESSION_WAITING);
}

export function onRemoveChatSessionWaiting(callback: (data: ChatSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.REMOVE_CHAT_SESSION_WAITING, (data) => {
    callback(data);
  });
}
export function offRemoveChatSessionWaiting() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.REMOVE_CHAT_SESSION_WAITING);
}

/** messages */
export function onReceiveOmniMessage(callback: (data: OmniChannelMessageDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.MESSAGE, async (data) => {
    let dataReceive = { ...data, senderId: isNaN(Number(data.senderId)) ? data.senderId : Number(data.senderId) };
    const message = await addMetadataOmniMessage(dataReceive);
    callback(message);
  });
}
export function offReceiveOmniMessage() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.MESSAGE);
}

/** call events */

export function onReceiveCallStartEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.START, async (data) => {
    callback(data);
  });
}
export function onReceiveCallDialAnswerEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.DIALANSWER, async (data) => {
    callback(data);
  });
}
export function onReceiveCallHangUpEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.HANGUP, async (data) => {
    callback(data);
  });
}
export function onReceiveCallDialingEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.DIALING, async (data) => {
    callback(data);
  });
}

export function offReceiveCallDialingEvent() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.DIALING);
}

export function onReceiveCallCdrEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.CDR, async (data) => {
    callback(data);
  });
}

export function onReceiveGetCallDetailsEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.GET_CALL_DETAILS, async (data) => {
    callback(data);
  });
}
export function offReceiveGetCallDetailsEvent() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.GET_CALL_DETAILS);
}

export function onGetWaitingCallsEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.GET_WAITING_CALLS, async (data) => {
    callback(data);
  });
}

export function onReceiveUpdateChatStatDetailEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.UPDATE_CHAT_STAT_DETAILS, async (data) => {
    callback(data);
  });
}

export function offReceiveUpdateChatStatDetailEvent() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.UPDATE_CHAT_STAT_DETAILS);
}

export function onReceiveUpdateCallStatDetailEvent(callback: (data: any) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.UPDATE_CALL_STAT_DETAILS, async (data) => {
    callback(data);
  });
}

export function offReceiveUpdateCallStatDetailEvent() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.UPDATE_CALL_STAT_DETAILS);
}

export function onReceiveTotalCallandChat(callback?: (data: AgentTotalCallAndChatCounter) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.AGENT_COUNTER_UPDATE, (data: AgentTotalCallAndChatCounter) => {
    // Log received data to debug extensionId reception

    callback?.(data);
  });
}

export function onReceiveAgentUpdateNotification(callback?: (data: UpdateAgentMapSocketDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.UPDATE_AGENT_MAP_SEAT, (data) => {
    callback?.(data);
  });
}

/** chat session history */
export function onReceiveChatSessionInProgress(callback: (data: ChatSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.ADD_CHAT_IN_PROGRESS, (data) => {
    callback(data);
  });
}
export function offReceiveChatSessionInProgress() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.ADD_CHAT_IN_PROGRESS);
}

export function onReceiveChatSessionAIInProgress(callback: (data: ChatSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.ADD_CHAT_AI_IN_PROGRESS, (data) => {
    callback(data);
  });
}
export function offReceiveChatSessionAIInProgress() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.ADD_CHAT_AI_IN_PROGRESS);
}

export function onRemoveChatSessionInProgress(callback: (data: ChatSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.REMOVE_CHAT_IN_PROGRESS, (data) => {
    callback(data);
  });
}
export function offRemoveChatSessionInProgress() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.REMOVE_CHAT_IN_PROGRESS);
}

export function onRemoveChatSessionAIInProgress(callback: (data: ChatSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.REMOVE_CHAT_AI_IN_PROGRESS, (data) => {
    callback(data);
  });
}
export function offRemoveChatSessionAIInProgress() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.REMOVE_CHAT_AI_IN_PROGRESS);
}

// chat monitoring user
export function onReceiveChatMonitoringUser(
  callback?: (data: { chatSessionId: number; user: UserCompactDto }) => void
) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.ADD_CHAT_MONITORING, (data) => {
    callback?.(data);
  });
}
export function offReceiveChatMonitoringUser() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.ADD_CHAT_MONITORING);
}

export function onRemoveChatMonitoringUser(callback?: (data: { chatSessionId: number; userId: number }) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.REMOVE_CHAT_MONITORING, (data) => {
    callback?.(data);
  });
}
export function offRemoveChatMonitoringUser() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.REMOVE_CHAT_MONITORING);
}

export function startChatMonitoring(chatSessionId: number) {
  omniChatSocketClient.socket.emit(OMNI_CHANNEL_EVENT.START_CHAT_MONITORING, { chatSessionId });
}

export function leaveChatSessionMonitoring(chatSessionId: number) {
  omniChatSocketClient.socket.emit(OMNI_CHANNEL_EVENT.LEAVE_CHAT_MONITORING, { chatSessionId });
}

export function onReceiveTicketInfo(callback: (data: { ticket: TicketDto; chatSessionId: number }) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.NEW_TICKET_INFO, (data) => {
    callback(data);
  });
}

export function onReceiveCallSessionAiProgressing(callback?: (data: CallSessionDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.CALL_SESSION_AI_PROCESSING, (data) => {
    callback?.(data);
  });
}
export function offReceiveCallSessionAiProgressing() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.CALL_SESSION_AI_PROCESSING);
}

export function joinCallSessionAiProcessing(callSessionId: number) {
  omniChatSocketClient.socket.emit(OMNI_CHANNEL_EVENT.JOIN_CALL_SESSION_AI, { callSessionId });
}

export function leaveCallSessionAiProcessing(callSessionId: number) {
  omniChatSocketClient.socket.emit(OMNI_CHANNEL_EVENT.LEAVE_CALL_SESSION_AI, { callSessionId });
}

export function onReceiveSpeakToText(callback?: (data: SpeakToTextDto) => void) {
  omniChatSocketClient.socket.on(OMNI_CHANNEL_EVENT.SPEAK_TO_TEXT, (data) => {
    callback?.(data);
  });
}
export function offReceiveSpeakToText() {
  omniChatSocketClient.socket.off(OMNI_CHANNEL_EVENT.SPEAK_TO_TEXT);
}
